import { desktopBreakpoint, mobileBreakpoint, wideScreenBreakpoint } from 'react-components'
import styled, { css } from 'styled-components'
import ExternalLink from '../common/external-link'

export const Container = styled.div`
    max-width: 83rem;
    margin: 0 auto;
    margin-bottom: 3rem;
    @media only screen and (max-width: ${mobileBreakpoint.max}px) {
        margin-bottom: 2rem;
    }
`

export const InnerContainer = styled.div`
    margin: 0 auto;
    max-width: 87.5rem;
    overflow: hidden;
    padding: 1rem 1rem 0.5rem;

    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        padding: 2rem 1.5rem 1rem;
    }
    @media only screen and (min-width: ${wideScreenBreakpoint.min}px) {
        padding: 2rem 4rem 1rem;
    }
`

export const HeadingSection = styled.section`
    margin-bottom: 3rem;
    text-align: center;
`

export const Title = styled.h1`
    font-size: 1.3rem;
    font-weight: 600;
    line-height: 1.6;
    color: ${({ theme }) => theme.colors.tfwBlack99};
    margin-bottom: 1rem;

    @media (max-width: ${mobileBreakpoint.max}px) {
        text-align: left;
    }
    @media (min-width: ${mobileBreakpoint.max}px) {
        font-size: 2rem;
    }
`

export const Subtitle = styled.div`
    font-size: 1rem;
    color: ${({ theme }) => theme.colors.tfwBlack99};
    line-height: 1.6;

    @media (max-width: ${mobileBreakpoint.max}px) {
        text-align: left;
    }
`

export const NoPropertiesText = styled.p`
    margin-top: 20px;
    color: ${({ theme }) => theme.colors.tfwBlack99};
    font-size: 14px;
`

export const SeoHref = styled(ExternalLink)`
    text-decoration: none;
`

export const StickyContainer = styled.div(
    ({ theme }) => css`
        position: sticky;
        top: 0;
        width: 100%;
        z-index: 100;
        border-bottom: ${theme.typography.border.radius.xxxSmall} ${theme.typography.border.style.solid} #e0e0e0;
        background-color: ${theme.colors.white};
    `,
)
